import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "13",
  viewBox: "0 0 8 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ColsIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("circle", {
      cx: "1.5",
      cy: "1.5",
      r: "1.5",
      fill: props.color || '#868E96'
    }, null, 8, _hoisted_2),
    _createElementVNode("circle", {
      cx: "6.5",
      cy: "1.5",
      r: "1.5",
      fill: props.color || '#868E96'
    }, null, 8, _hoisted_3),
    _createElementVNode("circle", {
      cx: "1.5",
      cy: "6.5",
      r: "1.5",
      fill: props.color || '#868E96'
    }, null, 8, _hoisted_4),
    _createElementVNode("circle", {
      cx: "6.5",
      cy: "6.5",
      r: "1.5",
      fill: props.color || '#868E96'
    }, null, 8, _hoisted_5),
    _createElementVNode("circle", {
      cx: "1.5",
      cy: "11.5",
      r: "1.5",
      fill: props.color || '#868E96'
    }, null, 8, _hoisted_6),
    _createElementVNode("circle", {
      cx: "6.5",
      cy: "11.5",
      r: "1.5",
      fill: props.color || '#868E96'
    }, null, 8, _hoisted_7)
  ]))
}
}

})